import React from "react";
import styled from "styled-components";
import ToolGroup from "./toolGroup";
import logger from "utils/logger";

const StyledGridTableRow = styled.tr`
  &:nth-child(odd) {
    background-color: #f9f9f9;
  }

  &:nth-child(even) {
    background-color: #fff;
  }

  &:hover {
    background-color: #f5f5f5;
  }

  cursor: ${({ cursor }) => cursor};
`;

const StyledTd = styled.td`
  border: 1px solid ${({ theme }) => theme.weakGray};
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  color: ${({ theme }) => theme.black};
  font-size: ${({ theme }) => theme.fontSize.nomal};
  font-size: 15px;
`;

const GridTableRow = ({
  auth,
  item = {},
  paths = [],
  tools,
  showTools,
  cursor = "unset",
  mode,
  onClick = (data) => {
    logger.log("点击table row: ", data);
  },
}) => {
  return (
    <StyledGridTableRow cursor={cursor} onClick={() => onClick(item)}>
      {paths.map((path, index) => (
        <StyledTd key={index}>{item[path]}</StyledTd>
      ))}
      {tools && showTools && (
        <StyledTd>
          <ToolGroup tools={tools} auth={auth} data={item} />
        </StyledTd>
      )}
    </StyledGridTableRow>
  );
};

export default GridTableRow;
